import { Redirect } from 'react-router-dom'

import { UserInfo } from '@/services/user'
import { Routes } from '@/router/routes'

export const securityGuard = (
  authUser: UserInfo,
  children: React.ReactElement,
  redirectBackTo: string
) => {
  if (!authUser?.completedFaceLivenessCheck) {
    return <Redirect to={Routes.FACE_LIVENESS_INSTRUCTIONS} />
  } else if (!authUser?.setup2FA) {
    return (
      <Redirect
        to={{
          pathname: Routes.SECURITY_SETTINGS,
          state: { redirectBackTo },
        }}
      />
    )
  }

  return children
}
